import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { ProxyGraphClients, abgGraphqlClient } from '@atlassian/temp-client-utils';

export function withApollo<T>(WrappedComponent: React.FC<T>, srcClient: string = ProxyGraphClients.ANS) {
  const ComponentWithApolloProvider = (props: T) => {
    return (
      <ApolloProvider client={abgGraphqlClient(srcClient)}>
        {/* @ts-ignore */}
        <WrappedComponent {...props} />
      </ApolloProvider>
    );
  };

  ComponentWithApolloProvider.displayName = `WithApollo(${
    WrappedComponent?.displayName || WrappedComponent?.name || 'Component'
  })`;

  return ComponentWithApolloProvider;
}
